'use strict';

exports.__esModule = true;
exports.IconContainer = exports.ButtonContent = exports.Spinner = exports.StyledButton = undefined;

var _templateObject = _taggedTemplateLiteralLoose(['\n      font-size: 16px;\n      height: 45px;\n      padding: ', ';\n    '], ['\n      font-size: 16px;\n      height: 45px;\n      padding: ', ';\n    ']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n    font-size: 18px;\n    height: 55px;\n    padding: ', ';\n  '], ['\n    font-size: 18px;\n    height: 55px;\n    padding: ', ';\n  ']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n      ', '\n      svg {\n        width: 28px;\n      }\n    '], ['\n      ', '\n      svg {\n        width: 28px;\n      }\n    ']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n              margin-left: ', ';\n            '], ['\n              margin-left: ', ';\n            ']),
    _templateObject5 = _taggedTemplateLiteralLoose(['\n              margin-right: ', ';\n            '], ['\n              margin-right: ', ';\n            ']),
    _templateObject6 = _taggedTemplateLiteralLoose(['\n    ', '\n    svg {\n      width: 34px;\n    }\n  '], ['\n    ', '\n    svg {\n      width: 34px;\n    }\n  ']),
    _templateObject7 = _taggedTemplateLiteralLoose(['\n            margin-left: ', ';\n          '], ['\n            margin-left: ', ';\n          ']),
    _templateObject8 = _taggedTemplateLiteralLoose(['\n            margin-right: ', ';\n          '], ['\n            margin-right: ', ';\n          ']),
    _templateObject9 = _taggedTemplateLiteralLoose(['\n      background-color: ', ';\n      transform: translateY(-1px);\n    '], ['\n      background-color: ', ';\n      transform: translateY(-1px);\n    ']),
    _templateObject10 = _taggedTemplateLiteralLoose(['\n    box-shadow: ', ';\n    transform: translateY(-1px);\n    filter: brightness(0.96);\n  '], ['\n    box-shadow: ', ';\n    transform: translateY(-1px);\n    filter: brightness(0.96);\n  ']),
    _templateObject11 = _taggedTemplateLiteralLoose(['\n  box-shadow: ', ';\n  border-radius: ', ';\n  ', ';\n  font-weight: ', ';\n  color: ', ';\n  background-color: ', ';\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  border: ', ';\n  transition: transform ', ' ease,\n    box-shadow ', ' ease,\n    background-color ', ' ease,\n    filter ', ' ease;\n  text-align: left;\n  &:not(:disabled):hover {\n    ', ';\n  }\n  &:focus {\n    outline: none;\n  }\n  /* F4: sichtbarer blauer Focus-Ring fuer Tastatur-Bedienung (A11y) \u2014 vorher fehlte er\n     ganz (nur outline:none). focus-visible -> kein Ring bei reinem Maus-Klick.\n     Bewusst :not(:disabled):focus-visible (gleiche Spezifitaet wie der Hover-Block) und\n     NACH ihm deklariert, damit der Ring auch bei gleichzeitigem Hover sichtbar bleibt;\n     Ring + Elevation in EINEM box-shadow, sonst wuerde eines das andere ueberschreiben. */\n  &:not(:disabled):focus-visible {\n    outline: none;\n    box-shadow: ', ',\n      ', ';\n  }\n  &:disabled,\n  &.disabled {\n    opacity: 0.5;\n    cursor: unset;\n    box-shadow: none;\n    transform: none;\n  }\n  position: relative;\n'], ['\n  box-shadow: ', ';\n  border-radius: ', ';\n  ', ';\n  font-weight: ', ';\n  color: ', ';\n  background-color: ', ';\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  border: ', ';\n  transition: transform ', ' ease,\n    box-shadow ', ' ease,\n    background-color ', ' ease,\n    filter ', ' ease;\n  text-align: left;\n  &:not(:disabled):hover {\n    ', ';\n  }\n  &:focus {\n    outline: none;\n  }\n  /* F4: sichtbarer blauer Focus-Ring fuer Tastatur-Bedienung (A11y) \u2014 vorher fehlte er\n     ganz (nur outline:none). focus-visible -> kein Ring bei reinem Maus-Klick.\n     Bewusst :not(:disabled):focus-visible (gleiche Spezifitaet wie der Hover-Block) und\n     NACH ihm deklariert, damit der Ring auch bei gleichzeitigem Hover sichtbar bleibt;\n     Ring + Elevation in EINEM box-shadow, sonst wuerde eines das andere ueberschreiben. */\n  &:not(:disabled):focus-visible {\n    outline: none;\n    box-shadow: ', ',\n      ', ';\n  }\n  &:disabled,\n  &.disabled {\n    opacity: 0.5;\n    cursor: unset;\n    box-shadow: none;\n    transform: none;\n  }\n  position: relative;\n']),
    _templateObject12 = _taggedTemplateLiteralLoose(['\n  border-top-color: ', ';\n  border-right-color: ', ';\n'], ['\n  border-top-color: ', ';\n  border-right-color: ', ';\n']),
    _templateObject13 = _taggedTemplateLiteralLoose(['\n  opacity: ', ';\n  width: ', ';\n'], ['\n  opacity: ', ';\n  width: ', ';\n']),
    _templateObject14 = _taggedTemplateLiteralLoose(['\n  ', ';\n  display: flex;\n  justify-content: center;\n  path,\n  line {\n    stroke: ', ';\n  }\n'], ['\n  ', ';\n  display: flex;\n  justify-content: center;\n  path,\n  line {\n    stroke: ', ';\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _spacing = require('../../styles/spacing');

var _Loader = require('../Loader');

var _focusRing = require('../ui/tokens/focusRing');

var _Button = require('./Button');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

var getColorByColorType = function getColorByColorType(color, theme) {
  switch (color) {
    case _Button.BUTTON_COLORS.PRIMARY:
      return theme.primary;
    case _Button.BUTTON_COLORS.SECONDARY:
      return theme.secondary;
    case _Button.BUTTON_COLORS.WHATSAPP:
      return '#25d366';
    case _Button.BUTTON_COLORS.APPROVE:
      // F4: gedaempftes Success-Token statt rohem CSS-Keyword (sonst grelles Gift-Gruen).
      return theme.approveColor || '#2e9e5b';
    default:
      break;
  }
};

var getButtonBgColor = function getButtonBgColor(color, theme, variant) {
  if (color === _Button.BUTTON_COLORS.DEFAULT || variant === _Button.BUTTON_VARIANTS.OUTLINED) {
    return theme.white;
  }
  return getColorByColorType(color, theme);
};

var getTextColor = function getTextColor(color, theme, variant) {
  if (variant === _Button.BUTTON_VARIANTS.OUTLINED) {
    return getColorByColorType(color, theme);
  }
  if (color === _Button.BUTTON_COLORS.DEFAULT) {
    return theme.textColor3;
  }
  return theme.white;
};

var getButtonSizeStyle = function getButtonSizeStyle(size) {
  if (size === _Button.BUTTON_SIZES.SMALL) {
    return (0, _styledComponents.css)(_templateObject, (0, _spacing.space)(0, 20));
  }
  return (0, _styledComponents.css)(_templateObject2, (0, _spacing.space)(0, 26));
};

var getBorderStyle = function getBorderStyle(color, theme, variant) {
  if (variant === _Button.BUTTON_VARIANTS.OUTLINED) {
    return '1px solid ' + getColorByColorType(color, theme);
  }
  return 'none';
};

var getIconStyle = function getIconStyle(size) {
  if (size === _Button.BUTTON_SIZES.SMALL) {
    return (0, _styledComponents.css)(_templateObject3, function (_ref) {
      var rightIcon = _ref.rightIcon;
      return rightIcon ? (0, _styledComponents.css)(_templateObject4, function (_ref2) {
        var withText = _ref2.withText;
        return withText ? '10px' : 0;
      }) : (0, _styledComponents.css)(_templateObject5, function (_ref3) {
        var withText = _ref3.withText;
        return withText ? '10px' : 0;
      });
    });
  }
  return (0, _styledComponents.css)(_templateObject6, function (_ref4) {
    var rightIcon = _ref4.rightIcon;
    return rightIcon ? (0, _styledComponents.css)(_templateObject7, function (_ref5) {
      var withText = _ref5.withText;
      return withText ? '20px' : 0;
    }) : (0, _styledComponents.css)(_templateObject8, function (_ref6) {
      var withText = _ref6.withText;
      return withText ? '20px' : 0;
    });
  });
};

// F4 (2026-06, Button-Modernisierung): box-shadow nur auf gefuellten Buttons — Outlined
// traegt keinen Schatten mehr (Audit-Fix); weiche Elevation-Tokens statt hartem 0 3px 6px.
var getBoxShadow = function getBoxShadow(disableBoxShadow, variant, theme) {
  if (disableBoxShadow || variant === _Button.BUTTON_VARIANTS.OUTLINED) {
    return 'none';
  }
  return theme.elevationSm || '0 3px 6px rgba(0, 0, 0, 0.16)';
};

// F4: echter Hover (1px-Lift + weichere Elevation + minimaler Helligkeits-Shift) statt
// opacity:0.9; Outlined hebt sich ueber einen dezenten Hintergrund ab (kein Schatten).
var getHoverStyle = function getHoverStyle(variant, theme) {
  if (variant === _Button.BUTTON_VARIANTS.OUTLINED) {
    return (0, _styledComponents.css)(_templateObject9, theme.grayF7);
  }
  return (0, _styledComponents.css)(_templateObject10, theme.elevationMd || '0 6px 16px rgba(0, 0, 0, 0.18)');
};

var StyledButton = exports.StyledButton = _styledComponents2.default.button(_templateObject11, function (_ref7) {
  var disableBoxShadow = _ref7.disableBoxShadow,
      variant = _ref7.variant,
      theme = _ref7.theme;
  return getBoxShadow(disableBoxShadow, variant, theme);
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.radiusMd || theme.borderRadiusDefault;
}, function (_ref9) {
  var size = _ref9.size;
  return getButtonSizeStyle(size);
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.fontWeightBold;
}, function (_ref11) {
  var color = _ref11.color,
      theme = _ref11.theme,
      variant = _ref11.variant;
  return getTextColor(color, theme, variant);
}, function (_ref12) {
  var color = _ref12.color,
      theme = _ref12.theme,
      variant = _ref12.variant;
  return getButtonBgColor(color, theme, variant);
}, function (_ref13) {
  var color = _ref13.color,
      theme = _ref13.theme,
      variant = _ref13.variant;
  return getBorderStyle(color, theme, variant);
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.durationFast || '0.15s';
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.durationFast || '0.15s';
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.durationFast || '0.15s';
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.durationFast || '0.15s';
}, function (_ref18) {
  var variant = _ref18.variant,
      theme = _ref18.theme;
  return getHoverStyle(variant, theme);
}, function (_ref19) {
  var theme = _ref19.theme;
  return (0, _focusRing.focusRingShadow)(theme);
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.elevationMd || '0 6px 16px rgba(0, 0, 0, 0.18)';
});

var Spinner = exports.Spinner = (0, _styledComponents2.default)(_Loader.Spin)(_templateObject12, function (_ref21) {
  var color = _ref21.color,
      theme = _ref21.theme,
      variant = _ref21.variant;
  return getTextColor(color, theme, variant);
}, function (_ref22) {
  var color = _ref22.color,
      theme = _ref22.theme,
      variant = _ref22.variant;
  return getTextColor(color, theme, variant);
});

var ButtonContent = exports.ButtonContent = _styledComponents2.default.span(_templateObject13, function (_ref23) {
  var isLoading = _ref23.isLoading;
  return isLoading ? '0.1' : '1';
}, function (_ref24) {
  var width = _ref24.width;
  return width;
});

var IconContainer = exports.IconContainer = _styledComponents2.default.div(_templateObject14, function (_ref25) {
  var size = _ref25.size;
  return getIconStyle(size);
}, function (_ref26) {
  var color = _ref26.color,
      theme = _ref26.theme,
      variant = _ref26.variant;
  return getTextColor(color, theme, variant);
});